import CodeSnippet from '../CodeSnippet';

export default function IntegrateCursor({ apiUrl, tokenPlaceholder }) {
  const base = `${apiUrl || 'https://api.osrouter.dev'}/api/v1`;
  const code = `# Cursor Settings → Models → Override OpenAI Base URL

Base URL: ${base}
API Key: ${tokenPlaceholder}`;

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-2">Cursor</h1>
      <p className="text-sm opacity-60 mb-6">
        In Cursor, open Settings → Models and override the OpenAI base URL. Use your os-router key as the API key.
      </p>
      <CodeSnippet code={code} language="config" />
      <ol className="mt-6 space-y-2 text-sm opacity-70 list-decimal list-inside">
        <li>Open Cursor Settings (Cmd/Ctrl + ,)</li>
        <li>Go to Models → OpenAI</li>
        <li>Enable override for OpenAI Base URL</li>
        <li>Paste the base URL and your os-router API key</li>
      </ol>
    </div>
  );
}
